(function() {
  class LearnMoreDrawer extends HTMLElement {
    constructor() {
      super()
      this.querySelectorAll('button[name="close"]').forEach(button => button.addEventListener('click', this.toggle.bind(this)))
    }

    toggle() {
      if (this.classList.contains('!visible')) {
        document.querySelector('body').classList.remove('no-scroll')
        this.classList.remove('!visible')
        this.querySelector('learn-more-drawer-content').classList.remove('!translate-y-0', 'md:!translate-x-0')
      } else {
        document.querySelector('body').classList.add('no-scroll')
        this.classList.add('!visible')
        this.querySelector('learn-more-drawer-content').classList.add('!translate-y-0', 'md:!translate-x-0')
      }
    }

    render(data) {
      this.querySelector('learn-more-drawer-title').innerHTML = data.title ?? ''
      this.querySelector('learn-more-drawer-subtitle').innerHTML = `<p class="line-clamp-2 text-[20px]">${data.subtitle}</p>` ?? ''
      this.querySelector('learn-more-drawer-description').innerHTML = data.drawerDescription ?? ''
      this.querySelector('#learn-more-drawer-image').src = data.image
      if(data.link) {
        this.querySelector('#learn-more-drawer-link').href = data.link
        this.querySelector('#learn-more-drawer-bottom').style.display = 'block';
      } else {
        this.querySelector('#learn-more-drawer-bottom').style.display = 'none';
      }
      this.toggle()
    }
  }

  customElements.define('learn-more-drawer', LearnMoreDrawer)

  class LearnMoreDrawerOverlay extends HTMLElement {
    constructor() {
      super()
      this.addEventListener('click', this.toggleDrawer.bind(this))
    }

    toggleDrawer() {
      this.closest('learn-more-drawer').toggle()
    }
  }

  customElements.define('learn-more-drawer-overlay', LearnMoreDrawerOverlay);
})();
